<div class="bill-ai-flow-overlay">
  <div class="bill-ai-flow-modal">
    <!-- Header -->
    <div class="bill-ai-flow-header">
      <div class="header-spacer"></div>
      <app-bill-ai-flow-step-header />
      <button class="close-btn" (click)="cancel()" title="Close">
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>

    <!-- Jen Zen Avatar (Consistent across steps, centered in modal) -->
    <div class="jen-zen-shell-container">
      <div class="jen-zen-glow"></div>
      <app-jen-zen-img [imgType]="JenZenImgType.HAPPY"></app-jen-zen-img>
      @if (state.jenZenMessage()) {
        <div class="jen-zen-shell-message">
          {{ state.jenZenMessage() }}
        </div>
      }
      @if (state.jenZenPauseReason(); as pauseReason) {
        <div class="jen-zen-pause-banner" role="status">
          <i class="material-symbols-rounded">bolt</i>
          <span>I paused Express Import here. {{ pauseReason }}.</span>
        </div>
      }
    </div>

    <!-- Flow-level blocked prompt: entities exist under a different entity -->
    <app-bill-ai-flow-migrate-prompt />

    <!-- Body: Split Panel -->
    <div class="bill-ai-flow-body">
      <!-- LEFT: Step content -->
      <div class="content-panel">
        @switch (state.currentStep()) {
          @case ('intro') {
            <app-bill-ai-flow-intro-step />
          }
          @case ('customer') {
            <app-bill-ai-flow-customer-step />
          }
          @case ('len') {
            <app-bill-ai-flow-len-step />
          }
          @case ('sa') {
            <app-bill-ai-flow-sa-step />
          }
          @case ('meter') {
            <app-bill-ai-flow-meter-step />
          }
          @case ('bill-review') {
            @if (state.fastTrackMode() === 'fast') {
              <app-bill-ai-flow-bill-overview />
            } @else {
              <app-bill-ai-flow-bill-review-step />
            }
          }
          @case ('summary') {
            <app-bill-ai-flow-summary-step (importComplete)="onImportComplete($event)" />
          }
        }
      </div>

      <!-- Resize Handle -->
      @if (!pdfCollapsed) {
        <div class="resize-handle" (mousedown)="onResizeStart($event)">
          <div class="resize-grip"></div>
        </div>
      }

      <!-- RIGHT: PDF Viewer -->
      @if (state.currentStep() === 'bill-review' || state.previewBillFileId()) {
        <div class="pdf-panel" [class.collapsed]="pdfCollapsed" [style.width.px]="pdfCollapsed ? 0 : pdfPanelWidth">
          <!-- Collapse chevron straddling the seam; always reachable while open. -->
          @if (!pdfCollapsed) {
            <button class="pdf-collapse-btn" (click)="pdfCollapsed = true"
                    title="Hide PDF" aria-label="Hide PDF">
              <i class="material-symbols-rounded">chevron_right</i>
            </button>
          }
          <!-- Dual Bill PDF Tabs -->
          @if (isDualBill) {
            <div class="pdf-tab-bar">
              <button class="pdf-tab" [class.active]="activePdfTab() === 'utility'" (click)="switchPdfTab('utility')">
                <span class="pdf-tab-label">Utility</span>
              </button>
              <button class="pdf-tab" [class.active]="activePdfTab() === 'supplier'" (click)="switchPdfTab('supplier')">
                <span class="pdf-tab-label">Supplier</span>
              </button>
            </div>
          }

          <div class="pdf-toolbar">
            <div class="toolbar-group">
              <button (click)="zoomOut()" class="toolbar-btn" title="Zoom out">
                <i class="material-symbols-rounded">zoom_out</i>
              </button>
              <button (click)="resetZoom()" class="toolbar-btn" title="Fit to width">
                <i class="material-symbols-rounded">fit_screen</i>
              </button>
              <button (click)="zoomIn()" class="toolbar-btn" title="Zoom in">
                <i class="material-symbols-rounded">zoom_in</i>
              </button>
            </div>
          </div>
          @if (pdfLoading) {
            <div class="pdf-empty">
              <mat-spinner diameter="32"></mat-spinner>
              <span>Loading PDF...</span>
            </div>
          } @else if (pdfSrc) {
            <div class="pdf-viewer">
              <ngx-extended-pdf-viewer
                [src]="pdfSrc"
                [zoom]="pdfZoom"
                [showToolbar]="false"
                [showSidebarButton]="false"
                [showFindButton]="false"
                [showPagingButtons]="false"
                [showZoomButtons]="false"
                [showPresentationModeButton]="false"
                [showOpenFileButton]="false"
                [showPrintButton]="false"
                [showDownloadButton]="false"
                [showSecondaryToolbarButton]="false"
                [showRotateButton]="false"
                [showHandToolButton]="false"
                [showScrollingButtons]="false"
                [showSpreadButton]="false"
                [showPropertiesButton]="false"
                [textLayer]="true"
                [backgroundColor]="ZenColors.textColorLight_4"
              ></ngx-extended-pdf-viewer>
            </div>
          } @else if (pdfError) {
            <div class="pdf-empty">
              <i class="material-symbols-rounded">error_outline</i>
              <span>{{ pdfError }}</span>
            </div>
          } @else {
            <div class="pdf-empty">
              <i class="material-symbols-rounded">picture_as_pdf</i>
              <span>No PDF to preview</span>
            </div>
          }
        </div>

        <!-- Collapsed: a vertical tab pinned to the right edge slides the PDF back out. -->
        @if (pdfCollapsed) {
          <button class="pdf-reopen-tab" (click)="pdfCollapsed = false" title="Show bill PDF" aria-label="Show bill PDF">
            <i class="material-symbols-rounded">chevron_left</i>
            <span class="pdf-reopen-label">Bill PDF</span>
          </button>
        }
      }
    </div>
  </div>
</div>
